import { httpAuth2 } from "@/api/auth";
import { httpPublic2 } from "@/api/public";
import { logOut } from "@/redux/actions/logout";
import store from "@/redux/store";

export const authRequests = {
  auth_challenge: function ({ data } = {}) {
    return httpPublic2.post("/v1/auth/auth_challenge", { json: data }).json();
  },

  /** X-custom-header v2 */
  change_password: function ({
    accessToken = window.localStorage.getItem("accessToken"),
    data,
  } = {}) {
    return httpAuth2
      .post("/v1/auth/change_password", { context: { accessToken }, json: data })
      .json();
  },

  complete_auto_signup: function ({ data } = {}) {
    return httpPublic2.post("/v1/auth/complete_auto_signup", { json: data }).json();
  },

  config: function (idToken) {
    return httpAuth2.post("/v1/auth/config", { context: { accessToken: idToken } }).json();
  },

  custom_auth: function ({ data } = {}) {
    return httpPublic2
      .post("/v1/auth/ext_user", { context: { showLoader: false }, json: data })
      .json();
  },

  fetch_profile: function ({ context }) {
    return httpAuth2.post("/v2/patient/profile", { context }).json();
  },

  get_user_idp: function ({ data } = {}) {
    return httpPublic2.post("/v1/auth/get_user_idp", { json: data }).json();
  },

  login: function ({ data } = {}) {
    return httpPublic2.post("/v1/auth/login", { json: data }).json();
  },

  mail_forgot_pw_code: function ({ data } = {}) {
    return httpPublic2.post("/v1/auth/forgot_password", { json: data }).json();
  },

  // Uses httpPublic2 with explicit Authorization header to avoid a circular dependency:
  // refreshAccessToken (called by tokenRefresh.ts) calls this function, so using
  // httpAuth2 here would re-trigger the 403 refresh hook and cause infinite recursion.
  new_id_token: function ({ data } = {}) {
    const token = localStorage.getItem("token");

    if (!token) {
      store.dispatch(logOut());
      throw new Error("Missing token");
    }

    // retry config — see authTyped.ts newIdToken for rationale. Same config
    // applied here for consistency; both functions call the same endpoint via
    // the same caller path.
    return httpPublic2
      .post("/v1/auth/new_id_token", {
        headers: { Authorization: token },
        json: data,
        retry: { limit: 1, methods: ["post"], statusCodes: [401, 408, 429, 500, 502, 503, 504] },
      })
      .json();
  },

  reset_forgotten_pw: function ({ data } = {}) {
    return httpPublic2.post("/v1/auth/forgot_password_confirm", { json: data }).json();
  },

  sign_up: function ({ context, data } = {}) {
    return httpPublic2.post("/v1/auth/signup", { context, json: data }).json();
  },

  validate_referral: function ({ data } = {}) {
    return httpPublic2.post("/v2/patient/referral_code", { json: data }).json();
  },

  verify_otc: function ({ data } = {}) {
    return httpPublic2.post("/v1/auth/verify_otc", { json: data }).json();
  },
};
